import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  emDataService,
  orgDataService,
  bcpDataService
} from 'app/services';
import {
  alerts,
  actionIcon,
  appReports
} from 'app/components/global';
import departments from './departments';
import assessmentInProgressDialog from './dialog.assessmentInProgressDialog';
import editDepartmentDialog from './departments/dialog.editDepartmentDialog';
import controller from './enterprise-modeling.controller';


export const routeConfig = {
  template: require('./enterprise-modeling.html'),
  controller: 'EnterpriseModelingController',
  controllerAs: 'enterpriseModelingVM',
};

export default angular.module('app.components.advisory.enterpriseModeling', [
  constants,
  loaderService,
  alerts,
  actionIcon,
  appReports,
  ssDialogService,
  userService,
  emDataService,
  orgDataService,
  bcpDataService,
  departments,
  assessmentInProgressDialog,
  editDepartmentDialog
])
  .controller('EnterpriseModelingController', controller)
  .name;
